import React from "react";
import { VegaFlex } from "@heartlandone/vega-react";
import dayjs from 'dayjs';
import Avatar from 'Components/Avatar/index';
import StarRatings from 'react-star-ratings';


function FeedbackList({feedbacks}) {

  const _renderFeedbacks = () => {
    return feedbacks.map(({
      rating = 0,
      feedback = '',
      createdBy = 'Bot',
      createdTime = '2024-10-15T19:50:45.9016288',
      avatarUrl
    }, index) => {
      return <VegaFlex direction={'col'} gap={'size-11'} key={index}>
        <VegaFlex alignItems={'center'} gap={'size-8'}>
          <Avatar avatarUrl={avatarUrl} name={createdBy} />
          <div className='f-size-14 f-weight-700 line-height-18'>{createdBy}</div>
          <div className='f-size-12 f-weight-400 line-height-16 font-light-text-color-secondary'>{dayjs(createdTime).format('MM/DD/YYYY, HH:mm')}</div>
        </VegaFlex>
        <VegaFlex className='p-l-30'>
          <StarRatings
            rating={rating}
            starRatedColor={'#FFDC83'}
            numberOfStars={5}
            name='rating'
            starEmptyColor='rgba(4, 4, 28, 0.64)'
            starSpacing={4}
            starDimension={14}
            svgIconViewBox='0 0 18 16'
            svgIconPath='M9.90255 0.5625C9.73692 0.21875 9.38692 0 9.00255 0C8.61817 0 8.2713 0.21875 8.10255 0.5625L6.09317 4.69688L1.60567 5.35938C1.23067 5.41563 0.91817 5.67813 0.802545 6.0375C0.68692 6.39688 0.78067 6.79375 1.04942 7.05938L4.30567 10.2813L3.53692 14.8344C3.47442 15.2094 3.63067 15.5906 3.94005 15.8125C4.24942 16.0344 4.6588 16.0625 4.9963 15.8844L9.00567 13.7438L13.015 15.8844C13.3525 16.0625 13.7619 16.0375 14.0713 15.8125C14.3807 15.5875 14.5369 15.2094 14.4744 14.8344L13.7025 10.2813L16.9588 7.05938C17.2275 6.79375 17.3244 6.39688 17.2057 6.0375C17.0869 5.67813 16.7775 5.41563 16.4025 5.35938L11.9119 4.69688L9.90255 0.5625Z' />
        </VegaFlex>
        <VegaFlex className='f-size-16 f-weight-400 line-height-24 p-l-30 font-light-text-color-primary' style={{ wordBreak: 'break-word'}}>
          {feedback}
        </VegaFlex>
      </VegaFlex>
    })
  }

  return (
    <>
      <VegaFlex direction={'col'} gap={'size-32'}>
        { _renderFeedbacks() }
      </VegaFlex>
    </>
  );
}

export default FeedbackList;
